import {createApi} from "@reduxjs/toolkit/query/react";
import {apiQueryTeletechV1} from "../utils/Extensions";
import {ValidationRequest, ValidationResponse} from "../../types/teletech/validation";


export const teletechApi = createApi({
    reducerPath: "teletech",
    baseQuery: apiQueryTeletechV1,
    endpoints: builder => ({
        validationMarkingList: builder.mutation<ValidationResponse, Partial<ValidationRequest>>({
            query: (body) => ({
                url: "/fiscalization/ownership-validation",
                method: "POST",
                body
            }),
            extraOptions: {maxRetries: 3}
        })
    })
})

export const {useValidationMarkingListMutation} = teletechApi